import React, {useRef, useEffect, useState} from 'react';
import styles from './App.module.css';
import Content from './species/websites/Content';
import Header from './species/websites/Header';
import Contact from './organs/Websites/Contact';
import Socials from './organs/Websites/Socials';
import {  Element } from 'react-scroll';
import CookiesContent from './cells/CookiesContent';
import { Link, Route, Switch } from "wouter";
import PhotographyHome from './species/photo/PhotographyHome';
import ArchiApp from './species/archiapp/ArchiApp';
import BooksHome from './species/books/BooksHome';
import InteriorHome from './species/interior/InteriorHome';
import LandingPage from './species/landing/LandingPage';
import PrivacyPolicy from './species/legal/PrivacyPolicy';
import CookiesPolicy from './species/legal/CookiesPolicy';
import LogoTopHeader from './organs/Landing/LogoTopHeader';

function App() {

  const footer = useRef<HTMLDivElement>(null);

  const [allowCookies, setAllowCookies] = useState<boolean>(false);
  const [cookiesSet, setCookiesSet] = useState<boolean>(false);


  return (
    <>
    <div className={styles.App}>
      
      <Switch>
        <Route path="/websites">
            <Header/>
            <Content cookies={allowCookies}/>
            <Element name="contact">
            <div id="footerId" className={styles.footer} ref={footer}>
                <Contact/>
            </div>
            </Element>
            <Socials/>
        </Route>
        <Route path="/photography" component={PhotographyHome}/>
        <Route path="/mobileapp" component={ArchiApp}/>
        {/* <Route path="/books" component={BooksHome}/> */}
        {/* <Route path="/interior" component ={InteriorHome}/> */}
        <Route path="/privacy" component={PrivacyPolicy}/>
        <Route path="/cookies" component={CookiesPolicy}/>
        <Route >
          
          <LandingPage/>
          <Socials/>
          {!cookiesSet && <CookiesContent cookies={setAllowCookies} areCookiesSet= {setCookiesSet}/>}
        </Route>
      </Switch>
   
    </div>
    </>
    
  );
}

export default App;
